let URL_LABELS = ''
let URL_WEBSOCKET = ''
let URL_IMAGES = ''
let URL_LABELS_PICKING = ''

switch(process.env.REACT_APP_ENV) {
    case 'production':
        URL_LABELS = 'https://apw.alpura.com:8243/eno/v1/api/v1/'
        URL_LABELS_PICKING = 'https://apw.alpura.com:8243/eno/v1/api/public/';
        URL_WEBSOCKET = 'https://alpuraone-socket-394644142950.us-central1.run.app/'
        URL_IMAGES = 'https://rga.alpura.com/label/dev/products/'
        break;
    case 'qa':
        URL_LABELS = 'https://apw.alpura.com:8243/eno/v1/api/v1/';
        URL_LABELS_PICKING = 'https://hub-backend.alpura.com/one/api/public/';
        URL_WEBSOCKET = 'https://alpuraone-socket-394644142950.us-central1.run.app/'
        URL_IMAGES = 'https://rga.alpura.com/label/dev/products/'
        break;
    default: 
        URL_LABELS = 'https://apw.alpura.com:8243/eno/v1/api/v1/'
        URL_LABELS_PICKING = 'https://apw.alpura.com:8243/eno/v1/api/public/';
        URL_WEBSOCKET = 'https://alpuraone-socket-394644142950.us-central1.run.app/'
        URL_IMAGES = 'https://rga.alpura.com/label/dev/products/'
        //URL_LABELS = 'http://189.254.4.194:7061/api/v1/';
}
    
export { URL_LABELS, URL_WEBSOCKET, URL_IMAGES, URL_LABELS_PICKING }
